import * as React from "react";

interface Profile {
  id: number;
  fullname: string;
  avatar: string;
  job_types: Array<{ title: string }>;
  position_types: Array<{ name: string }>;
  city: string;
  state: string;
  zip: string;
}

interface FavoriteProfilesProps {
  favorites: Profile[];
}

const FavoriteProfiles: React.FC<FavoriteProfilesProps> = ({
  favorites
}) => {

  return (
    <div className="container-fluid mt-4">
      <div className="row justify-content-center">
        <div className="col-12 col-xl-10">
          <div className="favorite-profiles-container">
            <div className="card">
              <div className="card-header">
                <div className="d-flex justify-content-between align-items-center">
                  <h5 className="mb-0">
                    <i className="fas fa-heart text-danger me-2"></i>
                    Favorite Profiles ({favorites.length})
                  </h5>
                </div>
              </div>

              <div className="card-body p-0">
                {favorites.length === 0 ? (
                  <div className="text-center py-5">
                    <i className="fas fa-heart fa-3x text-muted mb-3"></i>
                    <h5>No Favorite Profiles</h5>
                    <p className="text-muted">
                      Start building your talent pool by favoriting profiles.
                    </p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-hover mb-0">
                      <thead className="table-light">
                        <tr>
                          <th style={{ width: '400px' }}>Name</th>
                          <th>Job Types</th>
                          <th>Position Types</th>
                        </tr>
                      </thead>
                      <tbody>
                        {favorites.map((profile) => (
                          <tr key={profile.id}>
                            <td>
                              <div className="d-flex align-items-center">
                                <img
                                  src={profile.avatar}
                                  alt={`${profile.fullname}'s avatar`}
                                  className="rounded-circle me-3"
                                  style={{ width: 50, height: 50, objectFit: 'cover' }}
                                />
                                <div>
                                  <a
                                    href={`/profiles/${profile.id}`}
                                    className="text-decoration-none fw-bold text-dark"
                                  >
                                    {profile.fullname}
                                  </a>
                                  <div className="text-muted small">
                                    <i className="fas fa-map-marker-alt me-1"></i>
                                    {profile.city}, {profile.state}
                                  </div>
                                </div>
                              </div>
                            </td>

                            <td>
                              <div className="d-flex flex-wrap gap-1">
                                {profile.job_types.length > 0 ? (
                                  profile.job_types.map((jobType, index) => (
                                    <span
                                      key={index}
                                      className="badge bg-primary"
                                    >
                                      {jobType.title}
                                    </span>
                                  ))
                                ) : (
                                  <span className="text-muted">—</span>
                                )}
                              </div>
                            </td>

                            <td>
                              <div className="d-flex flex-wrap gap-1">
                                {profile.position_types.length > 0 ? (
                                  profile.position_types.map((posType, index) => (
                                    <span
                                      key={index}
                                      className="badge bg-info text-white"
                                    >
                                      {posType.name}
                                    </span>
                                  ))
                                ) : (
                                  <span className="text-muted">—</span>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>

              {favorites.length > 0 && (
                <div className="card-footer text-muted">
                  <small>
                    Click profile names to view detailed profiles.
                  </small>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FavoriteProfiles;
